import React, { useState, useContext, useEffect, useCallback } from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import Dialog from "../dialog";
import LoadingButton from "../loadingButton";
import ErrorMessage from "../../components/errorMessage";
import CloseIcon from "../../icons/closeIcon";
import styles from "./style.module.css";
import formStyles from "../form/style.module.css";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { CarContext } from "../../contexts/carProvider";
import { useUpdateCurrentCar } from "../../hooks/updateCurrentCar";

const schema = {
  type: "object",
  required: ["name"],
  properties: {
    name: {
      title: "Car Name",
      type: "string",
    },
  },
};

const uiSchema = {
  "ui:classNames": formStyles.formInner,
  "ui:rootFieldId": "add_car",
  name: {
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_12}`,
    "ui:placeholder": "Enter Car Name",
  },
  "ui:submitButtonOptions": {
    props: {
      className: formStyles.form_btn,
    },
  },
};

const AddCarModal = ({
  open,
  onClose,
  title = "Add New Car",
  carData = {},
  buttonTitle = "Add",
}) => {
  const axiosPrivate = useAxiosPrivate();
  const { fetchCars } = useContext(CarContext);
  const updateCurrentCar = useUpdateCurrentCar();
  const [formData, setFormData] = useState({ name: carData.name });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onFormSubmit = async (formData) => {
    setFormData(formData);
    setLoading(true);
    setErrorMessage("");
    try {
      if (buttonTitle === "Add") {
        const response = await axiosPrivate.post("/cars/add", {
          name: formData.name,
        });
        if (response.data.status === 1) {
          if (response.data.accessToken) {
            updateCurrentCar(response);
            // if (response.data.totalCars === 1) {
            handleDefaultConsumables({ carId: response.data.carId });
            // }
          }
          onClose();
          fetchCars();
        }
      } else {
        const response = await axiosPrivate.put(`/cars/${carData._id}`, {
          name: formData.name,
        });
        if (response.data.status === 1) {
          onClose();
          fetchCars();
        } else {
          setErrorMessage(response.data.message);
        }
      }
      setLoading(false);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleDefaultConsumables = useCallback(async (data) => {
    try {
      let url = `/consumables/default`;
      let options = {
        method: "POST",
        url,
        data,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          if (err.response) {

          }
        });
    } catch (error) {
      // console.error('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setLoading(false);
    setFormData({});
    onClose();
  };

  useEffect(() => {
    setFormData({ name: carData.name });
  }, [carData]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="680px">
      <div className={styles.add_car_modal}>
        <div className={styles.add_car_modal_header}>
          <div className={styles.add_car_modal_header_title}>{title}</div>
          <button
            type="button"
            className={styles.add_car_modal_header_close}
            onClick={handleClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div className={styles.add_car_modal_content}>
          <Form
            className={formStyles.form}
            schema={schema}
            uiSchema={uiSchema}
            formData={formData}
            validator={validator}
            showErrorList={false}
            omitExtraData={true}
            liveValidate={false}
            onSubmit={({ formData }) => {
              onFormSubmit(formData);
            }}
          >
            <div className={formStyles.form_actions}>
              <LoadingButton
                type="submit"
                loading={loading}
                title={buttonTitle}
              />
            </div>
          </Form>
          {errorMessage && <ErrorMessage message={errorMessage} mt />}
        </div>
      </div>
    </Dialog>
  );
};

export default AddCarModal;
